import React, { useMemo, useState, useEffect } from "react";
import { Container } from "reactstrap";
import {
  Grid,
  Button,
  Stack,
  Typography,
  Box,
  Tabs,
  Tab,
  Modal,
  Fade,
  TextField,
  IconButton,
  Checkbox,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  InputAdornment,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";
import { Controller, useForm } from "react-hook-form";
import { DataGrid } from "@mui/x-data-grid";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import RefreshIcon from "@mui/icons-material/Refresh";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import SendIcon from "@mui/icons-material/Send";
import { CloudUploadOutlined, Today } from "@mui/icons-material";
import moment from "moment";

import { date } from "yup";
const Fax = () => {
  const rights = useSelector((state) => state.login.rights);
  const [isLoading, setLoading] = useState(false);
  const [receivedRows, setReceivedRows] = useState([]);
  const [sentRows, setSentRows] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [tabValue, setTabValue] = useState("received");
  const [openModal, setOpenModal] = useState(false);
  const [searchFrom, setSearchFrom] = useState("");
  const [selectedFileName, setSelectedFileName] = useState("");
  const [openViewModal, setOpenViewModal] = useState(false);
  const [documentUrl, setDocumentUrl] = useState(null);

  document.title = "Fax | LuxBillingEHR";

  const token = localStorage.getItem("Token");
  const auth = `Bearer ${token}`;
  const headers = {
    Authorization: auth,
  };

  const {
    control,
    handleSubmit,
    reset,
    watch,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      to: "",
      subject: "",
      FaxText: "",
      file: null,
    },
    resolver: async (data) => {
      const errors = {};

      // Validate 'to' field
      if (!data.to) {
        errors.to = { message: "Fax number is required" };
      } else if (!/^\d{10}$/.test(data.to)) {
        errors.to = { message: "Fax number must be exactly 10 digits" };
      }

      // Validate 'subject' field
      if (!data.subject) {
        errors.subject = { message: "Subject is required" };
      }

      // Validate that either 'FaxText' or 'file' is provided
      if (!data.file) {
        errors.file = { message: "Document is required" };
      }

      return { values: data, errors };
    },
  });

  const watchFile = watch("file"); // Watch the file field to update selectedFileName
  const [selectedRows, setSelectedRows] = useState([]);
  const [OpenPatientModal, setOpenPatientModal] = useState(false);
  const handleOpenPatientModal = () => {
    setOpenPatientModal(true);
  };
  const handleClosePatientModal = () => {
    setOpenPatientModal(false);
  };
  const [patients, setPatients] = useState([]);

  useEffect(() => {
    if (OpenPatientModal) {
      fetchPatients();
    }
  }, [OpenPatientModal]);
  const [Patientloading, setPatientloading] = useState(false);
  const fetchPatients = async () => {
    setPatientloading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/Patients/getPatients`,
        { headers }
      );
      const filterData = response.filter((row) => row.status === "Active");
      setPatients(filterData);
    } catch (error) {
      console.error("Error fetching patients:", error);
      setPatients([]);
    } finally {
      setPatientloading(false);
    }
  };
  const [searchTerm, setSearchTerm] = useState("");

  const filteredPatients = patients.filter((p) => {
    const term = searchTerm.toLowerCase();
    return (
      p.firstName?.toLowerCase().includes(term) ||
      p.lastName?.toLowerCase().includes(term) ||
      p.address?.toLowerCase().includes(term) ||
      p.dob?.toLowerCase().includes(term)
    );
  });

  const handleCheckboxToggle = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((r) => r !== id) : [...prev, id]
    );
  };

  const handleSelectPatient = async (patientId) => {
    if (!selectedRows || selectedRows.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "No Fax Selected",
        text: "Please select at least one fax before choosing a patient.",
      });
      return;
    }

    const Today = new Date().toISOString().split("T")[0];

    Swal.fire({
      title: "Processing Faxes...",
      html: `<p id="statusText">Starting upload...</p>`,
      allowOutsideClick: true,
      didOpen: () => Swal.showLoading(),
    });

    try {
      let processedCount = 0;

      for (const [index, rowId] of selectedRows.entries()) {
        const row = receivedRows.find((r) => r.id === rowId);
        if (!row) continue;

        const { faxFileName, subUserId } = row;

        document.getElementById("statusText").innerHTML = `Fetching fax ${
          index + 1
        } of ${selectedRows.length}...`;

        // ✅ Step 1: Get fax file as base64
        const viewFaxUrl = `${
          process.env.REACT_APP_API_URL
        }/Fax/ViewFax?faxFileName=${encodeURIComponent(
          faxFileName
        )}&direction=IN&subUserId=${encodeURIComponent(subUserId)}`;

        const response = await axios.get(viewFaxUrl, { headers });
        const base64List = response?.base64File || [];

        // ✅ Step 2: Upload to PatientDocument
        const uploadFile = async (base64Raw) => {
          // Add "data:application/pdf;base64," if missing
          const base64WithPrefix = base64Raw.startsWith("data:")
            ? base64Raw
            : `data:application/pdf;base64,${base64Raw}`;

          document.getElementById(
            "statusText"
          ).innerHTML = `Uploading document ${++processedCount} of ${
            selectedRows.length
          }...`;

          const documentData = {
            patientId,
            date: Today,
            documentName: "Fax Documents.pdf",
            base64: base64WithPrefix,
            authId: 0,
            type: "fax",
            referringPhysiciansId: 0,
            notificationId: 0,
            authorizationcptId: 0,
          };

          await axios.post(
            `${process.env.REACT_APP_API_URL}/PatientDocument/PatientDocument?patientId=${patientId}`,
            documentData,
            { headers }
          );
        };

        if (Array.isArray(base64List)) {
          for (const b64 of base64List) await uploadFile(b64);
        } else if (typeof base64List === "string" && base64List.length > 0) {
          await uploadFile(base64List);
        }
      }

      Swal.fire({
        icon: "success",
        title: "Completed!",
        text: "All selected faxes have been uploaded successfully.",
        timer: 2500,
        showConfirmButton: false,
      });

      handleClosePatientModal();
    } catch (error) {
      console.error("Error processing faxes:", error.response?.data || error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while uploading faxes.",
      });
    }
  };

  const receivedColumns = useMemo(
    () => [
      {
        field: "select",
        headerName: "",
        headerAlign: "center",
        align: "center",
        headerClassName: "super-app-theme--header",
        cellClassName: "gridCell",
        sortable: false,
        flex: 0.1,
        renderCell: (params) => (
          <Checkbox
            checked={selectedRows.includes(params.row.id)}
            onClick={(e) => {
              e.stopPropagation();
              handleCheckboxToggle(params.row.id);
            }}
          />
        ),
      },

      {
        field: "id",
        headerName: "ID",
        headerClassName: "super-app-theme--header",
        cellClassName: "gridCell",
        sortable: false,
        flex: 0.2,
        align: "center",
        headerAlign: "center",
        renderCell: (params) => (
          <Button
            variant="contained"
            size="small"
            sx={{
              backgroundColor: "#def0edff",
              color: "black",
              "&:hover": { backgroundColor: "#00695C" },
              padding: "2px 8px",
              fontSize: "12px",
            }}
            onClick={(e) => {
              e.stopPropagation();
              handleCellClick(params);
            }}
          >
            {params.value}
          </Button>
        ),
      },
      {
        field: "faxFrom",
        headerName: "Caller ID",
        headerClassName: "super-app-theme--header",
        cellClassName: "gridCell",
        sortable: false,
        flex: 0.3,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "faxTo",
        headerName: "faxNumber",
        headerClassName: "super-app-theme--header",
        cellClassName: "gridCell",
        sortable: false,
        flex: 0.3,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "faxText",
        headerName: "Remote Id",
        headerClassName: "super-app-theme--header",
        cellClassName: "gridCell",
        sortable: false,
        flex: 0.3,
        align: "center",
        headerAlign: "center",
        renderCell: (params) => params.value || "N/A",
      },
      {
        field: "receivedDate",
        headerName: "Received Date",
        headerClassName: "super-app-theme--header",
        cellClassName: "gridCell",
        sortable: false,
        flex: 0.3,
        align: "center",
        headerAlign: "center",
renderCell: (params) => {
  if (!params.value) return "";
  return moment(params.value).format("MM-DD-YYYY, HH:mm");
},
    },
      {
        field: "pages",
        headerName: "Pages",
        headerClassName: "super-app-theme--header",
        cellClassName: "gridCell",
        sortable: false,
        flex: 0.2,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "status",
        headerName: "Status",
        headerClassName: "super-app-theme--header",
        cellClassName: "gridCell",
        sortable: false,
        flex: 0.3,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "delete",
        headerName: "Delete",
        headerClassName: "super-app-theme--header",
        sortable: false,
        flex: 0.2,
        align: "center",
        headerAlign: "center",
        renderCell: (params) => {
          const handleDelete = async () => {
            Swal.fire({
              title: "Are you sure?",
              text: "This fax will be marked inactive!",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#d33",
              cancelButtonColor: "#3085d6",
              confirmButtonText: "Yes, delete it!",
            }).then(async (result) => {
              if (result.isConfirmed) {
                try {
                  await axios.post(
                    `${process.env.REACT_APP_API_URL}/Fax/MarkInactive?id=${params.row.id}`,
                    null,
                    { headers }
                  );

                  Swal.fire({
                    title: "Deleted!",
                    text: "Fax has been marked inactive successfully.",
                    icon: "success",
                    timer: 2000,
                    showConfirmButton: false,
                  });
                  fetchReceivedFaxes();
                  // Optional: Refresh your data here after deletion
                  // e.g., refreshData();
                } catch (error) {
                  console.error("Error deleting fax:", error);
                  Swal.fire({
                    title: "Error!",
                    text: "Failed to delete fax. Please try again.",
                    icon: "error",
                  });
                }
              }
            });
          };

          return (
            <IconButton
              color="error"
              size="small"
              onClick={handleDelete}
              title="Delete Fax"
            >
              <DeleteIcon />
            </IconButton>
          );
        },
      },
    ],
    [receivedRows, selectedRows]
  );

  const sentColumns = useMemo(
    () => [
      {
        field: "id",
        headerName: "ID",
        headerClassName: "super-app-theme--header",
        cellClassName: "gridCell",
        sortable: false,
        flex: 0.2,
        align: "left",
        headerAlign: "left",
        renderCell: (params) => (
          <Button
            variant="contained"
            size="small"
            sx={{
              backgroundColor: "#def0edff",
              color: "black",
              "&:hover": { backgroundColor: "#00695C" },
              padding: "2px 8px",
              fontSize: "12px",
            }}
            onClick={(e) => {
              e.stopPropagation();
              handleCellClick(params);
            }}
          >
            {params.value}
          </Button>
        ),
      },
      {
        field: "faxTo",
        headerName: "Fax Number",
        headerClassName: "super-app-theme--header",
        cellClassName: "gridCell",
        sortable: false,
        flex: 0.5,
      },
      {
        field: "documentName",
        headerName: "Document Name",
        headerClassName: "super-app-theme--header",
        cellClassName: "gridCell",
        sortable: false,
        flex: 0.5,
        renderCell: (params) => params.value || "N/A",
      },
      {
        field: "faxText",
        headerName: "Fax Text",
        headerClassName: "super-app-theme--header",
        cellClassName: "gridCell",
        sortable: false,
        flex: 1,
        align: "center",
        headerAlign: "center",
        renderCell: (params) => params.value || "N/A",
      },
      {
        field: "receivedDate",
        headerName: "Sent Date",
        headerClassName: "super-app-theme--header",
        cellClassName: "gridCell",
        sortable: false,
        flex: 0.5,
        align: "left",
        headerAlign: "left",
        renderCell: (params) =>
          params.value
            ? new Date(params.value).toLocaleDateString("en-US", {
                month: "2-digit",
                day: "2-digit",
                year: "2-digit",
              })
            : "",
      },
      {
        field: "pages",
        headerName: "Pages",
        headerClassName: "super-app-theme--header",
        cellClassName: "gridCell",
        sortable: false,
        flex: 0.3,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "status",
        headerName: "Status",
        headerClassName: "super-app-theme--header",
        cellClassName: "gridCell",
        sortable: false,
        flex: 0.3,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "delete",
        headerName: "Delete",
        headerClassName: "super-app-theme--header",
        sortable: false,
        flex: 0.2,
        align: "center",
        headerAlign: "center",
        renderCell: (params) => {
          const handleDelete = async () => {
            Swal.fire({
              title: "Are you sure?",
              text: "This fax will be marked inactive!",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#d33",
              cancelButtonColor: "#3085d6",
              confirmButtonText: "Yes, delete it!",
            }).then(async (result) => {
              if (result.isConfirmed) {
                try {
                  await axios.post(
                    `${process.env.REACT_APP_API_URL}/Fax/MarkInactive?id=${params.row.id}`,
                    null,
                    { headers }
                  );

                  Swal.fire({
                    title: "Deleted!",
                    text: "Fax has been marked inactive successfully.",
                    icon: "success",
                    timer: 2000,
                    showConfirmButton: false,
                  });
                  fetchSentFaxes();
                  // Optional: Refresh your data here after deletion
                  // e.g., refreshData();
                } catch (error) {
                  console.error("Error deleting fax:", error);
                  Swal.fire({
                    title: "Error!",
                    text: "Failed to delete fax. Please try again.",
                    icon: "error",
                  });
                }
              }
            });
          };

          return (
            <IconButton
              color="error"
              size="small"
              onClick={handleDelete}
              title="Delete Fax"
            >
              <DeleteIcon />
            </IconButton>
          );
        },
      },
    ],

    []
  );

  const gridRowStyle = {
    boxShadow: 2,
    border: 2,
    borderRadius: 2,
    fontSize: "13.4px !important",
    color: "dark !important",
    borderColor: "#326C1D",
    "& .MuiDataGrid-cell:hover": {
      color: "rgba(5, 152, 236, 0.637) !important",
      fontSize: "14.6px !important",
    },
    "& .super-app-theme--header": {
      backgroundColor: "#377562",
      color: "white",
      fontSize: "16px !important",
    },
  };

  const fetchReceivedFaxes = () => {
    setLoading(true);
    const receivedApiUrl = `${process.env.REACT_APP_API_URL}/Fax/GetInboxFaxes`;

    axios
      .get(receivedApiUrl, {
        headers,
        params: {
          faxNumber: searchFrom || "",
        },
      })
      .then((response) => {
        const data = response.data || [];
        const mappedRows = data.map((fax) => ({
          id: fax.id || "",
          faxFrom: fax.callerId || "",
          faxTo: fax.faxNumber || "",
          documentName: fax.documentName || "",
          receivedDate: fax.receivedDate || "",
          pages: fax.pages || 1,
          viewedStatus: fax.viewedStatus || "UNREAD",
          inActive: fax.inActive || false,
          faxFileName: fax.faxFileName || "",
          direction: fax.direction || "IN",
          type: "RECEIVED",
          faxText: fax.faxText || "",
          status: fax.status || "",
          subUserId: fax.subUserId || "", // Add subUserId to the mapped rows
        }));
        setReceivedRows(mappedRows);
              const unreadFaxes = mappedRows.filter(
        (fax) => fax.viewedStatus?.toUpperCase() === "UNREAD"
      );
      const unreadFaxCount = unreadFaxes.length;
      localStorage.setItem("unreadFaxCount", unreadFaxCount);
      })
      .catch((error) => {
        console.error("Error fetching received faxes:", error);
        let errorMessage = "Failed to fetch received faxes.";
        if (error === "Request failed with status code 404") {
          errorMessage = "Efax: Add Fax Caller ID to receive fax.";
        } else if (error.response) {
          // Handle string response or JSON response
          errorMessage =
            typeof error.response === "string"
              ? error.response
              : JSON.stringify(error.response);
        } else {
          errorMessage = error.message || errorMessage;
        }
        Swal.fire({
          icon: "error",
          title: "Error",
          text: errorMessage,
          confirmButtonColor: "#d33",
        });
        setReceivedRows([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchSentFaxes = () => {
    setLoading(true);
    const sentApiUrl = `${process.env.REACT_APP_API_URL}/Fax/GetOutboxFaxes`;

    axios
      .get(sentApiUrl, {
        headers,
        params: {
          faxNumber: searchFrom || "",
        },
      })
      .then((response) => {
        const data = response || [];
        const mappedRows = data.map((fax) => ({
          id: fax.id || "",
          faxFrom: fax.callerId || "",
          faxTo: fax.faxNumber || "",
          documentName: fax.documentName || "",
          receivedDate: fax.receivedDate ? fax.receivedDate.split("T")[0] : "",
          pages: fax.pages || 1,
          viewedStatus: fax.viewedStatus || "UNREAD",
          inActive: fax.inActive || false,
          faxFileName: fax.faxFileName || "",
          direction: fax.direction || "OUT",
          type: "SENT",
          faxText: fax.faxText || "",
          status: fax.status || "",
        }));
        setSentRows(mappedRows);
      })
      .catch((error) => {
        console.error("Error fetching sent faxes:", error);
        let errorMessage = "Failed to fetch sent faxes.";
        if (error === "Request failed with status code 404") {
          errorMessage = "Efax: Add Fax Caller ID to receive fax.";
        } else if (error.response) {
          // Handle string response or JSON response
          errorMessage =
            typeof error.response === "string"
              ? error.response
              : JSON.stringify(error.response);
        } else {
          errorMessage = error.message || errorMessage;
        }
        Swal.fire({
          icon: "error",
          title: "Error",
          text: errorMessage,
          confirmButtonColor: "#d33",
        });
        setSentRows([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  //  const handleCellClick = async (params) => {
  //   if (params.field === "id") {
  //     try {
  //       setLoading(true);
  //       const direction = tabValue === "received" ? "IN" : "OUT";
  //       let apiUrl;
  //       if (params.row.type === "SENT") {
  //         apiUrl = `${
  //           process.env.REACT_APP_API_URL
  //         }/PatientDocument/ViewPatientDocument?path=${encodeURIComponent(
  //           params.row.faxFileName
  //         )}`;
  //       } else {
  //         apiUrl = `${
  //           process.env.REACT_APP_API_URL
  //         }/Fax/ViewFax?faxFileName=${encodeURIComponent(
  //           params.row.faxFileName
  //         )}&direction=${direction}`;
  //       }
  //       const response = await axios.get(apiUrl, { headers });
  //       let fileURL = response;
  //       if (typeof response === "object" && response.url) {
  //         fileURL = response.url;
  //       }
  //       window.open(fileURL, "_blank");
  //     } catch (error) {
  //       console.error("Error fetching fax file:", error);
  //       Swal.fire({
  //         icon: "error",
  //         title: "Error",
  //         text:
  //           "Failed to view fax file: " +
  //           (error.response?.data?.message || error.message),
  //         confirmButtonColor: "#d33",
  //       });
  //     } finally {
  //       setLoading(false);
  //     }
  //   }
  // };

  // const handleCellClick = async (params) => {
  //   if (params.field !== "id") return;

  //   setLoading(true);
  //   try {
  //     const direction = tabValue === "received" ? "IN" : "OUT";

  //     if (params.row.type === "SENT") {
  //       // PatientDocument/ViewPatientDocument: fetch blob and open
  //       const apiUrl = `${
  //         process.env.REACT_APP_API_URL
  //       }/PatientDocument/ViewPatientDocument?path=${encodeURIComponent(
  //         params.row.faxFileName
  //       )}`;

  //       // Make sure to set responseType: "blob"
  //       const response = await axios.get(apiUrl, { headers, responseType: "blob" });
  //       const blob = new Blob([response], { type: "application/pdf" });
  //       const fileURL = URL.createObjectURL(blob);
  //       window.open(fileURL, "_blank");
  //     } else {
  //       // Fax/ViewFax: already working (base64 handled)
  //       const apiUrl = `${
  //         process.env.REACT_APP_API_URL
  //       }/Fax/ViewFax?faxFileName=${encodeURIComponent(
  //         params.row.faxFileName
  //       )}&direction=${direction}`;

  //       const response = await axios.get(apiUrl, { headers });
  //       const base64File = response?.base64File;
  //       if (!base64File) throw new Error("No file received from API");

  //       const byteCharacters = atob(base64File);
  //       const byteNumbers = new Array(byteCharacters.length);
  //       for (let i = 0; i < byteCharacters.length; i++) {
  //         byteNumbers[i] = byteCharacters.charCodeAt(i);
  //       }
  //       const byteArray = new Uint8Array(byteNumbers);
  //       const blob = new Blob([byteArray], { type: "application/pdf" });
  //       const fileURL = URL.createObjectURL(blob);
  //       window.open(fileURL, "_blank");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching fax file:", error);
  //     Swal.fire({
  //       icon: "error",
  //       title: "Error",
  //       text:
  //         "Failed to view fax file: " +
  //         (error.response?.message || error.message),
  //       confirmButtonColor: "#d33",
  //     });
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const viewPatientDocument = async (faxFileName) => {
    try {
      setLoading(true);
      const firstFile = faxFileName.split(",")[0].trim();
      const apiUrl = `${
        process.env.REACT_APP_API_URL
      }/PatientDocument/ViewPatientDocument?path=${encodeURIComponent(
        firstFile
      )}`;

      const response = await axios.get(apiUrl, { headers });

      // Check if response has a URL
      let fileURL = response;
      if (typeof response === "object" && response.url) {
        fileURL = response.url;
      }

      window.open(fileURL, "_blank");
    } catch (error) {
      console.error("Error viewing PatientDocument:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          "Failed to view document: " +
          (error.response?.data?.message || error.message),
        confirmButtonColor: "#d33",
      });
    } finally {
      setLoading(false);
    }
  };

  const viewFaxDocument = async (faxFileName, subUserId) => {
    try {
      setLoading(true);
      const direction = tabValue === "received" ? "IN" : "OUT";
      const apiUrl = `${
        process.env.REACT_APP_API_URL
      }/Fax/ViewFax?faxFileName=${encodeURIComponent(
        faxFileName
      )}&direction=${direction}&subUserId=${encodeURIComponent(subUserId)}`;
      const response = await axios.get(apiUrl, { headers });
      const base64File = response?.base64File; // direct response
      if (!base64File) throw new Error("No file received from API");

      const byteCharacters = atob(base64File);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(blob);
      window.open(fileURL, "_blank");
    } catch (error) {
      console.error("Error viewing Fax document:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to view fax: " + error.message,
        confirmButtonColor: "#d33",
      });
    } finally {
      setLoading(false);
    }
  };

  // const handleCellClick = (params) => {
  //   if (params.field !== "id") return;

  //   if (params.row.type === "SENT") {
  //     viewPatientDocument(params.row.faxFileName);
  //   } else {
  //     viewFaxDocument(params.row.faxFileName);
  //   }
  // };

  const handleCellClick = (params) => {
    if (params.field !== "id") return;

    if (params.row.type === "SENT") {
      viewPatientDocument(params.row.faxFileName);
    } else {
      viewFaxDocument(params.row.faxFileName, params.row.subUserId); // Pass subUserId
    }
  };
  const handleCloseViewModal = () => {
    setOpenViewModal(false);
    setDocumentUrl(null); // Clear the document URL
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleSearch = () => {
    if (tabValue === "received") {
      fetchReceivedFaxes();
    } else {
      fetchSentFaxes();
    }
  };

  const handleClear = () => {
    setSearchFrom("");
    if (tabValue === "received") {
      fetchReceivedFaxes();
    } else {
      fetchSentFaxes();
    }
  };

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedFileName("");
    reset();
  };

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      let fileBase64 = "";
      if (data.file) {
        fileBase64 = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(data.file);
        });
      }

      const faxNumberWithCountryCode = `1${data.to}`;

      const payload = {
        faxNumber: faxNumberWithCountryCode,
        fileBase64: fileBase64 || null,
        subject: data.subject,
        documentName: data.subject,
        FaxText: data.FaxText || "",
      };

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/Fax/UploadFax`,
          payload,
          { headers }
        );

        // actual API response data
        const apiResponse = response;

        let errorMessage = "";
        if (apiResponse.portalResponse) {
          try {
            const parsedPortalResponse = JSON.parse(apiResponse.portalResponse);

            if (parsedPortalResponse.Status === "Failed") {
              errorMessage = parsedPortalResponse.Result;
            }
          } catch (parseError) {
            console.error("Error parsing portalResponse:", parseError);
          }
        }

        if (errorMessage) {
          // Agar fail hua
          Swal.fire({
            icon: "error",
            title: "Fax Failed",
            text: errorMessage,
            confirmButtonColor: "#d33",
            didOpen: () => {
              const swalEl = document.querySelector(".swal2-container");
              if (swalEl) {
                swalEl.style.zIndex = "3000"; // MUI modal ke upar
              }
            },
          });
          return; // yahan hi stop karna hoga, neeche success na chale
        }

        // Agar fail nahi hua to success
        Swal.fire({
          icon: "success",
          title: "Fax Sent",
          text: "Your fax has been sent successfully!",
          confirmButtonColor: "#3085d6",
        });
      } catch (error) {
        console.error("Error sending fax:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.message || "Fax failed to send.",
          confirmButtonColor: "#d33",
        });
      }

      Swal.fire({
        icon: "success",
        title: "Fax Sent",
        text: "Your fax has been sent successfully!",
        confirmButtonColor: "#3085d6",
      }).then(() => {
        setRefresh(!refresh);
      });

      handleCloseModal();
    } catch (error) {
      console.error("Error uploading fax:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "Failed to send fax.",
        confirmButtonColor: "#d33",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (tabValue === "received") {
      fetchReceivedFaxes();
    } else if (tabValue === "sent") {
      fetchSentFaxes();
    }
  }, [refresh, tabValue]);

  return (
    <div className="page-content">
      <Modal
        open={OpenPatientModal}
        sx={{ zIndex: 900 }}
        onClose={handleClosePatientModal}
      >
        <Box
          sx={{
            position: "absolute",
            top: "54%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "90%", sm: "80%", md: "60%" },
            bgcolor: "background.paper",
            borderRadius: 3,
            boxShadow: 24,
            p: 3,
            maxHeight: "80vh",
            display: "flex",
            flexDirection: "column",
            overflowY: "auto",
          }}
        >
          {/* Header Section */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
            sx={{
              backgroundColor: "#E9F5EF",
              borderRadius: "12px",
              padding: "0.6rem 1rem",
              boxShadow: "0 2px 4px rgba(55,117,98,0.25)",
            }}
          >
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{
                color: "#00695C",
                letterSpacing: "0.5px",
                fontSize: { xs: "1rem", sm: "1.1rem" },
              }}
            >
              Patient List
            </Typography>

            <IconButton
              onClick={handleClosePatientModal}
              sx={{
                color: "#00695C", // dark teal for icon
                backgroundColor: "#C6F3DD", // minty soft green background
                transition: "0.3s",
                "&:hover": { backgroundColor: "#00695C", color: "#FFFFFF" }, // inverted hover
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          <Box display="flex" justifyContent="center" mb={2}>
            <TextField
              placeholder="Search patient..."
              variant="outlined"
              size="small"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ color: "#377562", fontSize: 20 }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                width: { xs: "90%", sm: "70%", md: "50%" }, // responsive width
                "& .MuiOutlinedInput-root": {
                  borderRadius: "25px",
                  backgroundColor: "#F9FCFB",
                  transition: "0.3s ease",
                  "& fieldset": {
                    borderColor: "#9BC7B0",
                  },
                  "&:hover fieldset": {
                    borderColor: "#377562",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#00695C",
                    boxShadow: "0 0 6px rgba(55,117,98,0.3)",
                  },
                },
                "& input": {
                  fontSize: "0.9rem",
                  padding: "8px 10px",
                },
                "& .MuiInputBase-input::placeholder": {
                  color: "#6b6b6b",
                  opacity: 0.8,
                },
              }}
            />
          </Box>

          <Divider sx={{ mb: 2 }} />

          {/* Table or Loader Section */}
          <Box
            sx={{
              flexGrow: 1,
              // overflow: "hidden",
            }}
          >
            {Patientloading ? (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="300px"
              >
                <CircularProgress />
              </Box>
            ) : patients.length === 0 ? (
              <Typography textAlign="center" color="text.secondary">
                No patients found.
              </Typography>
            ) : (
              <TableContainer
                component={Paper}
                sx={{
                  border: "2px solid #377562",
                  borderRadius: 2,
                  boxShadow: "0 0 6px rgba(55,117,98,0.3)",
                  maxHeight: { xs: 200, sm: 250, md: 300 }, // responsive height
                  overflowY: "auto",
                }}
              >
                <Table
                  stickyHeader
                  sx={{
                    tableLayout: "fixed",
                    minWidth: 400,
                    "& th, & td": {
                      fontSize: { xs: "0.75rem", sm: "0.8rem", md: "0.85rem" }, // smaller responsive font
                      padding: { xs: "4px 6px", sm: "6px 8px" }, // tighter spacing
                    },
                  }}
                >
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#E9F5EF" }}>
                      <TableCell
                        sx={{
                          width: { xs: "22%", sm: "20%" },
                          fontWeight: "bold",
                          color: "#00695C",
                        }}
                      >
                        Last Name
                      </TableCell>
                      <TableCell
                        sx={{
                          width: { xs: "22%", sm: "20%" },
                          fontWeight: "bold",
                          color: "#00695C",
                        }}
                      >
                        First Name
                      </TableCell>
                      <TableCell
                        sx={{
                          width: { xs: "16%", sm: "14%" },
                          fontWeight: "bold",
                          color: "#00695C",
                        }}
                      >
                        DOB
                      </TableCell>
                      <TableCell
                        sx={{
                          width: { xs: "28%", sm: "34%" },
                          fontWeight: "bold",
                          color: "#00695C",
                        }}
                      >
                        Address
                      </TableCell>
                      <TableCell
                        sx={{
                          width: { xs: "10%", sm: "10%" },
                          fontWeight: "bold",
                          color: "#00695C",
                        }}
                        align="center"
                      >
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {filteredPatients.length > 0 ? (
                      filteredPatients.map((p) => (
                        <TableRow
                          key={p.id}
                          hover
                          sx={{
                            "&:hover": { backgroundColor: "#f1f8f6" },
                            borderBottom: "1px solid #8ABF9B",
                          }}
                        >
                          <TableCell
                            sx={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <b>{p.lastName || "N/A"}</b>
                          </TableCell>
                          <TableCell
                            sx={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {p.firstName || "N/A"}
                          </TableCell>
                          <TableCell>
                            {p.dob ? p.dob.split("T")[0] : "N/A"}
                          </TableCell>
                          <TableCell
                            sx={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {p.address || "N/A"}
                          </TableCell>
                          <TableCell align="center">
                            <Button
                              variant="contained"
                              size="small"
                              onClick={() => handleSelectPatient(p.id)}
                              sx={{
                                textTransform: "none",
                                fontSize: { xs: "0.7rem", sm: "0.75rem" },
                                backgroundColor: "#00695C",
                                px: { xs: 1, sm: 1.5 },
                                "&:hover": { backgroundColor: "#004D40" },
                              }}
                            >
                              Send
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={5} align="center">
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ fontSize: { xs: "0.75rem", sm: "0.8rem" } }}
                          >
                            No matching patients found.
                          </Typography>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Box>

          <Divider sx={{ mt: 2, mb: 1 }} />

          {/* Footer */}
          <Box textAlign="right">
            <Button
              onClick={handleClosePatientModal}
              variant="contained"
              sx={{
                backgroundColor: "#00695C",
                "&:hover": { backgroundColor: "#004D40" },
                color: "#fff",
              }}
            >
              Close
            </Button>
          </Box>
        </Box>
      </Modal>
      <Container>
        <Grid
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          {rights.add_fax && (
            <Button
              className="Button"
              sx={{
                color: "white",
              }}
              onClick={handleOpenModal}
              startIcon={<AddOutlinedIcon />}
            >
              NEW FAX
            </Button>
          )}
        </Grid>
        <Grid
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <Button
            className="Button"
            sx={{
              color: "white",
            }}
            onClick={() => setRefresh(!refresh)}
            startIcon={<RefreshIcon />}
          >
            REFRESH
          </Button>
        </Grid>

        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="fax tabs"
          sx={{ mb: 2 }}
        >
          <Tab label="InBox" value="received" sx={{ color: "#26A69A" }} />
          <Tab label="Sent" value="sent" sx={{ color: "#26A69A" }} />
        </Tabs>
        <Grid container spacing={1}>
          <Grid
            item
            xs={6}
            sx={{
              gap: 2,
              backgroundColor: "#E0F2F1",
              p: 2,
              borderRadius: 1,
            }}
          >
            <Typography
              variant="body1"
              sx={{ color: "#26A69A", fontWeight: "bold" }}
            >
              Fax Number
            </Typography>
            <TextField
              value={searchFrom}
              onChange={(e) => setSearchFrom(e.target.value)}
              variant="outlined"
              size="small"
              fullWidth
              placeholder="Please Enter Fax Number"
              sx={{ input: { color: "#000" } }}
            />
          </Grid>
          <Grid
            item
            xs={6}
            sx={{
              mt: 2,
              gap: 2,
              display: "flex",
              p: 2,
              borderRadius: 1,
            }}
          >
            <Button
              className="Button"
              sx={{
                color: "white",
                height: "36px",
                minHeight: "36px",
              }}
              onClick={handleClear}
              startIcon={<ClearIcon />}
            >
              CLEAR
            </Button>
            <Button
              className="Button"
              sx={{
                color: "white",
                height: "36px",
                minHeight: "36px",
              }}
              onClick={handleSearch}
              startIcon={<SearchIcon />}
            >
              SEARCH
            </Button>
            <Button
              className="Button"
              sx={{
                color: "white",
                height: "36px",
                minHeight: "36px",
              }}
              onClick={handleOpenPatientModal}
              disabled={selectedRows.length === 0}
            >
              Send to Patient Documents
            </Button>
          </Grid>
        </Grid>

        <Grid mt={2}>
          {isLoading ? (
            <Grid sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
              <CircularProgress />
            </Grid>
          ) : tabValue === "received" ? (
            receivedRows.length === 0 ? (
              <Typography variant="h6" align="center" sx={{ color: "#26A69A" }}>
                No Record Found
              </Typography>
            ) : (
              <Box sx={{ height: 400, overflowY: "auto" }}>

              <DataGrid
                rows={receivedRows}
                columns={receivedColumns}
                pagination
                getRowId={(row) => row.id}
                pageSizeOptions={[25]}
                sx={gridRowStyle}
                rowHeight={30}
                initialState={{
                  pagination: { paginationModel: { pageSize: 25, page: 0 } },
                }}
                onCellClick={handleCellClick}
              />
              </Box>
            )
          ) : sentRows.length === 0 ? (
            <Typography variant="h6" align="center" sx={{ color: "#26A69A" }}>
              No Record Found
            </Typography>
          ) : (
            <Box sx={{ height: 400, overflowY: "auto" }}>

            <DataGrid
              rows={sentRows}
              columns={sentColumns}
              pagination
              pageSizeOptions={[25]}
              sx={gridRowStyle}
              rowHeight={30}
              initialState={{
                pagination: { paginationModel: { pageSize: 25, page: 0 } },
              }}
              onCellClick={handleCellClick}
            />
            </Box>
          )}
        </Grid>

        {/* Modal for sending a new fax */}
       <Modal open={openModal} onClose={handleCloseModal} closeAfterTransition>
  <Fade in={openModal}>
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: { xs: "95%", sm: "85%", md: "70%", lg: "55%", xl: "45%" },
        bgcolor: "background.paper",
        boxShadow: 24,
        p: { xs: 2, sm: 3, md: 4 },
        borderRadius: 2,
        backgroundColor: "#E0F2F1",
        maxHeight: "90vh",
        overflowY: "auto",
        scrollbarWidth: "thin",
        "&::-webkit-scrollbar": { width: "8px" },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#26A69A",
          borderRadius: "10px",
        },
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 2,
          flexWrap: "wrap",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            color: "#000",
            fontWeight: 600,
            textAlign: { xs: "center", sm: "left" },
            flexGrow: 1,
          }}
        >
          New Fax
        </Typography>

        <IconButton
          aria-label="close"
          onClick={handleCloseModal}
          sx={{
            color: "red",
            "&:hover": { backgroundColor: "rgba(255,0,0,0.1)" },
          }}
        >
          <CancelOutlinedIcon />
        </IconButton>
      </Box>

      {/* Form */}
      <form onSubmit={handleSubmit(onSubmit)}>
        {/* To */}
        <Grid
          container
          spacing={2}
          sx={{ mb: 2 }}
        >
          <Grid item xs={12}>
            <Typography
              variant="body1"
              sx={{
                color: "#26A69A",
                fontWeight: "bold",
                mb: 1,
              }}
            >
              To:
            </Typography>
            <Controller
              name="to"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  variant="outlined"
                  fullWidth
                  size="small"
                  placeholder="Enter 10-digit Fax Number"
                  sx={{ input: { color: "#000" } }}
                  error={!!errors.to}
                  helperText={errors.to?.message}
                  inputProps={{
                    maxLength: 10,
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                  }}
                />
              )}
            />
          </Grid>

          {/* Subject */}
          <Grid item xs={12}>
            <Typography
              variant="body1"
              sx={{
                color: "#26A69A",
                fontWeight: "bold",
                mb: 1,
              }}
            >
              Subject:
            </Typography>
            <Controller
              name="subject"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  variant="outlined"
                  fullWidth
                  size="small"
                  placeholder="Subject"
                  sx={{ input: { color: "#000" } }}
                  error={!!errors.subject}
                  helperText={errors.subject?.message}
                />
              )}
            />
          </Grid>

          {/* Text */}
          <Grid item xs={12}>
            <Typography
              variant="body1"
              sx={{
                color: "#26A69A",
                fontWeight: "bold",
                mb: 1,
              }}
            >
              Text:
            </Typography>
            <Controller
              name="FaxText"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  variant="outlined"
                  fullWidth
                  placeholder="Enter text here..."
                  multiline
                  minRows={3}
                  maxRows={8}
                  sx={{ textarea: { color: "#000" } }}
                  error={!!errors.FaxText}
                  helperText={errors.FaxText?.message}
                />
              )}
            />
          </Grid>

          {/* File Upload */}
          <Grid item xs={12}>
            <Controller
              name="file"
              control={control}
              render={({ field: { onChange, value } }) => (
                <Box
                  sx={{
                    border: "2px dashed #26A69A",
                    borderRadius: 2,
                    p: { xs: 2, sm: 3 },
                    textAlign: "center",
                    cursor: "pointer",
                    transition: "0.2s",
                    "&:hover": {
                      backgroundColor: "rgba(38,166,154,0.05)",
                    },
                  }}
                  onDrop={(e) => {
                    e.preventDefault();
                    const file = e.dataTransfer.files[0];
                    onChange(file);
                    setSelectedFileName(file?.name || "");
                  }}
                  onDragOver={(e) => e.preventDefault()}
                >
                  <CloudUploadOutlined
                    sx={{ fontSize: 48, color: "#26A69A", mb: 1 }}
                  />
                  <Typography variant="h6" sx={{ mb: 2 }}>
                    Drag & Drop or Click to Upload
                  </Typography>

                  <Button
                    variant="contained"
                    component="label"
                    sx={{
                      width: { xs: "100%", sm: "220px" },
                      color: "white",
                      backgroundColor: "#26A69A",
                      "&:hover": { backgroundColor: "#00695C" },
                    }}
                  >
                    Choose File
                    <input
                      type="file"
                      hidden
                      onChange={(e) => {
                        const file = e.target.files[0];
                        onChange(file);
                        setSelectedFileName(file?.name || "");
                      }}
                    />
                  </Button>

                  {value && (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        mt: 2,
                        flexWrap: "wrap",
                        gap: 1,
                      }}
                    >
                      <Typography sx={{ color: "#26A69A" }}>
                        File selected: {selectedFileName}
                      </Typography>
                      <IconButton
                        onClick={() => {
                          setSelectedFileName("");
                          onChange(null);
                        }}
                        sx={{
                          color: "#d33",
                          "&:hover": {
                            backgroundColor: "rgba(255,0,0,0.1)",
                          },
                        }}
                      >
                        <ClearIcon />
                      </IconButton>
                    </Box>
                  )}

                  {errors.file && (
                    <Typography sx={{ color: "red", mt: 1 }}>
                      {errors.file.message}
                    </Typography>
                  )}
                </Box>
              )}
            />
          </Grid>
        </Grid>

        {/* Buttons */}
        <Grid
          container
          justifyContent="flex-end"
          spacing={2}
          sx={{
            mt: 2,
            flexWrap: "wrap",
          }}
        >
          <Grid item>
            <Button
              className="Button"
              sx={{
                color: "#FFF",
                backgroundColor: "#E64A19",
                "&:hover": { backgroundColor: "#D84315" },
                width: { xs: "100%", sm: "auto" },
              }}
              onClick={handleCloseModal}
              startIcon={<CloseIcon />}
            >
              DISCARD
            </Button>
          </Grid>

          <Grid item>
            <Button
              className="Button"
              sx={{
                color: "#FFF",
                backgroundColor: "#26A69A",
                "&:hover": { backgroundColor: "#00695C" },
                width: { xs: "100%", sm: "auto" },
              }}
              type="submit"
              disabled={isSubmitting}
              startIcon={<SendIcon />}
            >
              {isSubmitting ? <CircularProgress size={24} /> : "SEND"}
            </Button>
          </Grid>
        </Grid>
      </form>
    </Box>
  </Fade>
</Modal>


        {/* Modal for viewing the document */}
        <Modal
          open={openViewModal}
          onClose={handleCloseViewModal}
          closeAfterTransition
        >
          <Fade in={openViewModal}>
            <Grid
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "80%",
                maxWidth: 1000,
                height: "80%",
                bgcolor: "background.paper",
                boxShadow: 24,
                p: 4,
                borderRadius: 2,
                backgroundColor: "#E0F2F1",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <IconButton
                aria-label="close"
                onClick={handleCloseViewModal}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: "#26A69A",
                }}
              >
                <CancelOutlinedIcon />
              </IconButton>
              <Typography variant="h6" mb={2} sx={{ color: "#26A69A" }}>
                View Document
              </Typography>
              {documentUrl ? (
                <iframe
                  src={documentUrl}
                  style={{
                    width: "100%",
                    height: "100%",
                    border: "none",
                    borderRadius: "4px",
                  }}
                  title="Document Viewer"
                />
              ) : (
                <Typography variant="body1" sx={{ color: "#26A69A" }}>
                  Loading document...
                </Typography>
              )}
            </Grid>
          </Fade>
        </Modal>
      </Container>
    </div>
  );
};

export default Fax;
